<div class="wrapper__form">
  <div
    class="d-flex flex-column flex-xl-row align-items-xl-center mb-4 mt-3 justify-content-between">
    <div class="d-flex flex-row align-items-center">
      <h4 class="wrapper__form__title h3-tipografia-govco mb-0" *ngIf="title">
        {{ title }}
      </h4>
      <button
        *ngIf="titleModalVisibility"
        type="button"
        class="btn-govco outline-btn-govco p-1 ms-2"
        data-bs-toggle="modal"
        [attr.data-bs-target]="'#titulo' + generateModalId(titleModal)"
        [attr.aria-label]="'Más información sobre {{ titleModal }}'">
        <span class="govco-svg govco-question icos__tooltip"></span>
      </button>
      <div
        class="modal fade"
        [id]="'titulo' + generateModalId(titleModal)"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true">
        <div
          class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-{{
            titleSizeModal
          }}">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title h5-tipografia-govco"
                *ngIf="titleModal">
                {{ titleModal }}
              </h5>
              <button
                type="button"
                class="btn-close"
                (click)="closeModal('titulo' + generateModalId(titleModal))"
                aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <p class="text2-tipografia-govco">
                {{ titleContentModalText }}
              </p>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn-govco fill-btn-govco"
                (click)="closeModal('titulo' + generateModalId(titleModal))"
                [attr.aria-label]="'salir' | translate">
                {{"salir" | translate}}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <p
      class="m-0 text3-tipografia-govco wrapper__form__camposObligatory"
      *ngIf="withCamposObligatorios">
      <span class="text-danger">*</span>{{'tramites.campos-obligatorios' | translate}}
    </p>
  </div>
  <form
    [formGroup]="form"
    (ngSubmit)="onSubmit()"
    [ngClass]="{ 'three-columns': tresColumnas }"
    class="wrapper__form__content row g-3">
    <ng-container *ngFor="let field of fields">
      <ng-container *ngIf="field.isSubtitle && field.visible">
        <div class="col-12">
          <h4 class="wrapper__form__content__subtitle" *ngIf="!field.isParrafo && field.isParrafo === undefined">
            {{ field.subtitleText }}
          </h4>
          <p class="text3-tipografia-parrafo-govco" *ngIf="field.isParrafo && field.isParrafo !== undefined">
            {{ field.subtitleText }}
          </p>
        </div>
      </ng-container>
      <ng-container *ngIf="!field.isSubtitle">
        <div
          [ngClass]="field.width ? 'col-12 col-xl-' + field.width : 'col-12'"
          *ngIf="field.visible !== false"
          class="">
          <div class="d-flex flex-row align-items-center mb-2">
            <label
              [for]="field.name"
              class="form-label text3-tipografia-govco mb-0">
              {{ field.label }}
              <span *ngIf="field.required" class="text-danger">*</span>
            </label>
            <div *ngIf="field.modalVisibility === true">
              <button
                type="button"
                class="btn-govco outline-btn-govco ms-3 p-1"
                data-bs-toggle="modal"
                [attr.data-bs-target]="'#' + generateModalId(field.titleModal)"
                [attr.aria-label]="'Más información sobre {{ field.titleModal }}'">
                <span class="govco-svg govco-info personalitate__Icon"></span>
              </button>
              <div
                class="modal fade"
                [id]="generateModalId(field.titleModal)"
                tabindex="-1"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true">
                <div
                  class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-{{
                    field.sizeModal
                  }}">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title h5-tipografia-govco"
                        *ngIf="field.titleModal">
                        {{ field.titleModal }}
                      </h5>
                      <button
                        type="button"
                        class="btn-close"
                        (click)="closeModal(generateModalId(field.titleModal))"
                        aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                      <ng-container [ngSwitch]="field.contentTypeModal">
                        <ng-container *ngSwitchCase="'text'">
                          <p class="text2-tipografia-govco">
                            {{ field.contentModalText }}
                          </p>
                        </ng-container>
                        <ng-container *ngSwitchCase="'list'">
                          <ul class="list-group">
                            <li
                              class="list-group-item"
                              *ngFor="let item of field.contentModalList">
                              {{ item }}
                            </li>
                          </ul>
                        </ng-container>
                        <ng-container *ngSwitchCase="'image'">
                          <img
                            [src]="field.contentModalImage"
                            class="img-fluid"
                            alt="Content image"/>
                        </ng-container>
                        <ng-container *ngSwitchCase="'component'">
                          <ng-container
                            *ngComponentOutlet="
                              dynamicComponent
                            "></ng-container>
                        </ng-container>
                      </ng-container>
                    </div>
                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn-govco fill-btn-govco"
                        (click)="closeModal(generateModalId(field.titleModal))"
                        [attr.aria-label]="'salir' | translate">
                        {{"salir" | translate}}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <ng-container [ngSwitch]="field.type">
            <input
              *ngSwitchCase="'text'"
              [type]="field.type"
              [id]="field.name"
              [formControlName]="field.name"
              [name]="field.name"
              [placeholder]="field.placeholder ?? ''"
              class="form-control"
              [ngClass]="{
                'is-invalid':
                  form.get(field.name)?.invalid &&
                  form.get(field.name)?.touched,
                'autocompleted':
                  form.get(field.name)?.value && form.get(field.name)?.pristine,
              }"
              (blur)="field.noConvertToUpperCase ? undefined : transformToUppercase(field.name, field.type); onChange($event)"
              autocomplete="off"
              [maxlength]="field.maxLength ?? null"/>
            <div class="entradas-de-texto-govco m-2" *ngSwitchCase="'password'">
              <div class="input-group">
                <input
                  class="form-control actived-events-govco"
                  (blur)="onChange($event)"
                  [type]="showPassword[field.name] ? 'text' : 'password'"
                  [id]="field.name"
                  [formControlName]="field.name"
                  [name]="field.name"
                  [placeholder]="field.placeholder ?? ''"
                  [ngClass]="{
                  'is-invalid':
                  form.get(field.name)?.invalid &&
                  form.get(field.name)?.touched,
                  'autocompleted':
                  form.get(field.name)?.value && form.get(field.name)?.pristine
                  }"
                  style="width: 80% !important;"
                />
                <button
                  type="button"
                  *ngIf="field.type === 'password'"
                  class="btn govco-icon govco-eye"
                  [ngClass]="{
                    'govco-eye': showPassword[field.name],
                    'govco-eye-slash': !showPassword[field.name],
                  }"
                  [attr.aria-label]="
                    showPassword[field.name]
                      ? 'Ocultar contraseña'
                      : 'Mostrar contraseña'
                  "
                  (click)="togglePasswordVisibility(field.name)"></button>
              </div>
            </div>
            <!--Se elimina (blur) duplicado y el (input) para evitar el salto del cursor en los campos de correo -->
            <input
              *ngSwitchCase="'email'"
              [type]="'text'"
              [id]="field.name"
              [formControlName]="field.name"
              [name]="field.name"
              [placeholder]="field.placeholder ?? ''"
              class="form-control"
              [ngClass]="{
                'is-invalid':
                  form.get(field.name)?.invalid &&
                  form.get(field.name)?.touched,
                'autocompleted':
                  form.get(field.name)?.value && form.get(field.name)?.pristine,
              }"
              (blur)="transformToUppercase(field.name, field.type); onChange($event)"
              autocomplete="off"/>

            <input
              *ngSwitchCase="'number'"
              (blur)="onChange($event)"
              [type]="field.type"
              [id]="field.name"
              [formControlName]="field.name"
              [name]="field.name"
              [placeholder]="field.placeholder ?? ''"
              class="form-control"
              [ngClass]="{
                'is-invalid':
                  form.get(field.name)?.invalid &&
                  form.get(field.name)?.touched,
                'autocompleted':
                  form.get(field.name)?.value && form.get(field.name)?.pristine,
              }"
              autocomplete="off"
              [maxlength]="field.maxLength ?? null"/>
              <input
                *ngSwitchCase="'decimal'"
                type="text"
                [id]="field.name"
                [formControlName]="field.name"
                [name]="field.name"
                [placeholder]="field.placeholder ?? ''"
                class="form-control"
                [ngClass]="{
                  'is-invalid': form.get(field.name)?.invalid &&
                                form.get(field.name)?.touched,
                  'autocompleted':
                    form.get(field.name)?.value && form.get(field.name)?.pristine,
                }"
                (input)="validateDecimalInput($event, field.maxLength!)"
                autocomplete="off"
              />
            <input
              *ngSwitchCase="'tel'"
              (blur)="onChange($event)"
              [type]="field.type"
              [id]="field.name"
              [formControlName]="field.name"
              [name]="field.name"
              [placeholder]="field.placeholder ?? ''"
              class="form-control"
              [ngClass]="{
                'is-invalid':
                  form.get(field.name)?.invalid &&
                  form.get(field.name)?.touched,
                'autocompleted':
                  form.get(field.name)?.value && form.get(field.name)?.pristine,
              }"
              autocomplete="off"/>

            <textarea
              *ngSwitchCase="'textarea'"
              [attr.style]="field.noConvertToUpperCase ? null : 'text-transform: uppercase'"
              [id]="field.name"
              rows="6"
              [formControlName]="field.name"
              [name]="field.name"
              [placeholder]="field.placeholder ?? ''"
              class="form-control"
              [ngClass]="{
                'is-invalid':
                  form.get(field.name)?.invalid &&
                  form.get(field.name)?.touched,
                'autocompleted':
                  form.get(field.name)?.value && form.get(field.name)?.pristine,
              }"
              (blur)="field.noConvertToUpperCase ? undefined : transformToUppercase(field.name, field.type); onChange($event)"
              autocomplete="off"></textarea>
            <input
              *ngSwitchCase="'date'"
              [id]="field.name"
              [formControlName]="field.name"
              [name]="field.name"
              type="date"
              placeholder="dd/mm/aaaa"
              [ngClass]="{
                'ng-invalid ng-dirty':
                  form.get(field.name)?.invalid && form.get(field.name)?.touched,
                'autocompleted':
                  form.get(field.name)?.value && form.get(field.name)?.pristine
              }"
              [max]="getFormattedMaxDate(field.name, field.isMaxDate)"
              (change)="onChange(field.name, $event)"
              autocomplete="off"/>
            <!-- input fecha y hora -->
            <input
              *ngSwitchCase="'datetime'"
              [id]="field.name"
              [formControlName]="field.name"
              [name]="field.name"
              type="datetime-local"
              [ngClass]="{
                'ng-invalid ng-dirty':
                  form.get(field.name)?.invalid && form.get(field.name)?.touched,
                'autocompleted':
                  form.get(field.name)?.value && form.get(field.name)?.pristine
              }"
              [max]="getFormattedMaxDateTime(field.name, field.isMaxDate)"
              (change)="onChange(field.name, $event)"
              autocomplete="off"
            />
            <!-- fin input fecha y hora -->
              <ng-container *ngIf="form.get(field.name)?.disabled && field.type === 'select'; else selectTemplate">
                <input
                type="text"
                class="form-control"
                [value]="obtenerNombreOpcion(field)"
                [ngClass]=" {
                'autocompleted':
                obtenerNombreOpcion(field) }"
                [disabled]="true">
              </ng-container>

              <ng-template #selectTemplate>
                <ng-select
                  *ngSwitchCase="'select'"
                  [items]="field.options ?? []"
                  bindLabel="Nombre"
                  bindValue="Id"
                  [multiple]="field.multiple ?? false"
                  [formControlName]="field.name"
                  placeholder="{{'tramites.seleccione-opcion' | translate}}"
                  [notFoundText]="'No se encontraron resultados'"
                  [ngClass]="{
                    'is-invalid':
                      form.get(field.name)?.invalid &&
                      form.get(field.name)?.touched,
                    'autocompleted':
                      form.get(field.name)?.value && form.get(field.name)?.pristine
                  }"
                  (change)="onChange(field.name, $event)">
                </ng-select>
              </ng-template>

            <div *ngSwitchCase="'checkbox'">
              <div
                class="form-check checkboxPersonalite"
                *ngFor="let option of field.options">
                <input
                  type="checkbox"
                  (change)="onChange($event)"
                  class="form-check-input"
                  [id]="field.name + '-' + option.Id"
                  [formControlName]="field.name"
                  [name]="field.name"
                  [value]="option.Id"/>
                <label
                  class="form-check-label"
                  [for]="field.name + '-' + option.Id"
                >{{ option.Nombre }}</label
                >
              </div>
            </div>

            <div *ngSwitchCase="'radio'">
              <div
                class="radio-seleccion-govco ms-2"
                *ngFor="let option of field.options">
                <input
                  type="radio"
                  [name]="field.name"
                  (change)="onChange($event)"
                  [id]="field.name + '-' + option.Id"
                  [formControlName]="field.name"
                  [value]="option.Id"/>
                <label [for]="field.name + '-' + option.Id">{{
                    option.Nombre
                  }}</label>
              </div>
            </div>
            <!-- Imagen -->
            <div *ngIf="field.type === 'image'">
              <div *ngIf="!(previewImages[field.name] || field.value); else imagePreview">
                <div class="input-group">
                  <input
                    *ngSwitchCase="'image'"
                    [id]="field.name"
                    [name]="field.name"
                    type="file"
                    [accept]="(field.imageExtensions && field.imageExtensions.length > 0)
                    ? field.imageExtensions?.join(',') : 'image/*'"
                    [ngClass]="{
                      'ng-invalid ng-dirty':
                        form.get(field.name)?.invalid && form.get(field.name)?.touched,
                      'autocompleted':
                        form.get(field.name)?.value && form.get(field.name)?.pristine
                    }"
                    (change)="onFileChange($event, field.name)"
                    class="form-control d-none"
                  />
                  <label class="input-group-text w-100 justify-content-center" [for]="field.name">
                    {{ (field.placeholder ?? '') | translate }}
                    <small class="ms-2" *ngIf="field.imageExtensions && field.imageExtensions.length > 0">
                     ({{ field.imageExtensions.join(', ') }})
                    </small>
                  </label>
                </div>
              </div>
              <!-- Template de vista previa -->
              <ng-template #imagePreview>
                <div class="mt-2 text-center">
                  <img
                    [src]="previewImages[field.name] || field.value"
                    alt="Vista previa"
                    width="300"
                    height="150"
                    style="object-fit: contain; border: 1px solid #ddd; border-radius: 4px;"
                  />
                  <br />
                  <button
                    type="button"
                    class="btn btn-danger btn-sm mt-2"
                    (click)="removeImage(field.name)"
                    aria-label="Eliminar">
                    <span class="fa fa-trash"></span>
                  </button>
                </div>
              </ng-template>
            </div>
            <!-- Fin imagen -->
          </ng-container>
          <span
            class="text4-tipografia-govco"
            *ngIf="field.tooltip !== undefined"
          >{{ field.tooltip }}</span
          >

          <div
            *ngIf="
              form.get(field.name)?.invalid && form.get(field.name)?.touched
              && field.type !== 'password'"
            class="invalid-feedback">
            {{ getErrorMessage(field) }}
          </div>
          <div
          *ngIf="
            form.get(field.name)?.invalid && form.get(field.name)?.touched
            && field.type === 'password'">
          <span class="invalid-feedback"
          [innerHTML]="getErrorMessage(field)"></span>
        </div>
        </div>
      </ng-container>
    </ng-container>
    <div class="col-12 d-flex justify-content-end"
         [ngClass]="{ 'three-columns-button': tresColumnas }"
         *ngIf="withSubmitButton">
      <button
        type="submit"
        class="btn btn-govco outline-btn-govco"
        [disabled]="!alwaysEnableSubmit && form.invalid"
        [attr.aria-label]="sumbitButtonText">
        {{ sumbitButtonText }}
      </button>
    </div>
  </form>
</div>
